export const PUBMED_URL_PATTERN = /pubmed\.ncbi\.nlm\.nih\.gov\/(\d+)/;

export const extractPmidFromUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  const match = url.match(PUBMED_URL_PATTERN);
  return match ? match[1] : null;
};

export const getPaperStableId = (paper, fallback = null) => {
  if (!paper || typeof paper !== "object") {
    return fallback !== null ? String(fallback) : null;
  }

  const id =
    paper.pmid ||
    paper.PMID ||
    extractPmidFromUrl(paper.url || paper.URL) ||
    paper.pmcid ||
    paper.PMCID ||
    paper.id ||
    paper.url ||
    paper.URL ||
    fallback;

  if (id === null || id === undefined || id === "") return null;
  return String(id);
};
